<template>
  <div class="mb-3">
    <div>Vous vous trouvez actuellement sur la billetterie non sportive. Pour vous inscrire à un parcours, suivez ce
      lien:</div>
    <v-btn class="inscription_btn shadowed" size="default" variant="tonal" @click="leave_billetterie()">Se rendre sur le
      module sportif</v-btn>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    leave_billetterie() {
      let base_module = this.$route.params.base_module;
      let base_module_sportif = base_module.replace("BILLETTERIE_", "");
      this.$router.push({ name: "Home", params: { base_module: base_module_sportif } });
    },
  },
};
</script>

<style lang="scss" scoped></style>